<template>
  <div class="text-center">
    <template v-if="isCancel">
      <span class="ui-icon-circle-close club-timeout-expired-icon text-error--text" />
      <div class="text-h5 text--text mt-2 mb-4">
        Запись отменена
      </div>
      <div class="text-body-2 text-secondary--text mb-4">
        Время ожидания оплаты закончилось.<br>
        Можете записаться к специалисту снова
      </div>
      <v-btn
        v-if="doctorPageUrl"
        color="primary"
        depressed
        @click="handleToSpecialistPage"
      >
        Записаться повторно
      </v-btn>
    </template>
    <template v-else>
      <img
        src="/static/_v1/pd/icons/ui-kit/club/club-check-close.svg"
        alt="Иконка крестик"
        width="72"
        height="72"
        class="d-block mb-4 mx-auto"
      >
      <h1 class="text-h5 text--text mb-4">
        Вы записались, но не успели
        <br>воспользоваться скидкой
      </h1>
      <p class="text-body-1 text--text mb-4">
        Поэтому в клинике нужно будет оплатить
        полную стоимость <span class="text-no-wrap">приёма — {{ fullPrice }}</span>.
      </p>
    </template>
  </div>
</template>

<script lang="ts" setup>
const props = defineProps<{
  doctorPageUrl: string
  isCancel: boolean
  fullPrice: string | number
}>()

function handleToSpecialistPage() {
  if (!props.doctorPageUrl) {
    window.history.back()
    return
  }

  window.location.assign(props.doctorPageUrl)
}
</script>

<style>
.club-timeout-expired-icon {
  font-size: 72px;
}
</style>
